<template>
    <form id="warrantyform" class="cosmos-form">
        <div v-if="!loggedin" class="grid-x">
            <div class="cell">
                <div class="grid-x">
                    <div class="medium-7 cell">
                    <p>Already have an account? Sign in.</p>
                       <sign-in notmodal="1" v-on:logged-in="checkloggedin()"></sign-in>
                    </div>
                    <div class="medium-4 medium-offset-1 cell text-center">
                        <a href="/account/register"><div class="paint-circle large neutral-lovable" alt="Register for an Account"><h2 class="alternate">Register</h2></div></a>
                        <p><strong>Don't currently have a sign in?</strong><br>
                        Then <a href="/account/register">click here to register</a>.</p>
                    </div>   
                </div>
            </div> 
        </div>
        <div v-else-if="!sent">
            <div class="grid-x grid-padding-x" style="padding-bottom: 2rem;">
                <div class="cell"><h2>Contact Details</h2><hr /></div>
                <div class="large-10 large-offset-1 cell">
                    <div class="grid-x  grid-padding-x">
                        <div class="cell small-4" style="margin-bottom:1rem;">
                            <div class="cell"><p><label for="customer_name" class="large">Name*</label></p></div>
                        </div>                         
                        <div class="small-8 cell">
                            <div class="holder">
                            <p><input ref="customerName" type="text" id="customer_name" v-model="form.customer_name"  required="1"  placeholder="Name*" aria-label="Contact Name*" /></p>
                            <p v-if="errors.includes('customer_name')" class="error">Please provide a contact name</p>
                            </div>
                        </div>
                    </div>
                    <div class="grid-x  grid-padding-x">
                        <div class="cell small-4" style="margin-bottom:1rem;">
                            <div class="cell"><p><label class="large">Email</label></p></div>
                        </div>                        
                        <div class="small-8 cell">
                            <div class="holder">
                            <p>{{ form.email }}</p>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>       
            <div class="grid-x grid-padding-x" style="padding-bottom: 2rem;">
                <div class="cell"><h2>Product Details</h2><hr /></div>
                <div class="large-10 large-offset-1 cell">
                    <div class="grid-x">
                        <div class="cell medium-4">
                            <div class="cell"><p>Alternative Flooring Carpet*</p></div>
                            <div v-if="form.carpet_code != null">
                                <a href="#" @click.prevent="form.carpet_code = null"><small>change carpet</small></a>
                            </div>   
                        </div>                         
                        <div class="cell medium-8">
                            <sample-lookup :value="form.carpet_code" v-on:chosen="form.carpet_code = $event;" :enabled="form.carpet_code == null"></sample-lookup>
                            <p v-if="errors.includes('carpet_code')" class="error">Please select product</p>
                        </div> 
                    </div>
                </div>
                <div v-if="form.carpet_code" class="large-10 large-offset-1 cell">
                    <div class="grid-x">                
                        <div class="cell medium-4"><p>Floor covering type*</p></div>
                        <div class="cell medium-8">
                            <div class="radiocheckboxes">
                                <label>
                                    <input type="radio" name="flooring_type" v-model="form.flooring_type" value="Carpet" aria-label="Carpet">
                                    <span style="width: 50px; display:inline-block"><img src="/assets/images/icons/AF_Carpet_icon.svg" alt="Carpet"></span> Carpet
                                </label>
                                <label>
                                    <input type="radio" name="flooring_type" v-model="form.flooring_type" value="Rug" aria-label="Rug">
                                    <span style="width: 50px; display:inline-block"><img src="/assets/images/icons/AF_Rug_icon.svg" alt="Rug"></span> Rug
                                </label>  
                                <label>
                                    <input type="radio" name="flooring_type" v-model="form.flooring_type" value="Runner" aria-label="Rug">
                                    <span style="width: 50px; display:inline-block"><img src="/assets/images/icons/AF_Runner_icon.svg" alt="Runner"></span> Runner
                                </label>                                                               
                            </div>
                            <p v-if="errors.includes('flooring_type')" class="error">Please select flooring type</p>
                        </div> 
                        <div class="cell"><hr /></div> 
                    </div> 
                    <div v-if="form.flooring_type">
                        <div class="grid-x">
                            <div class="cell medium-4"><p>Where did you buy this item?</p></div>
                            <div class="cell medium-8">
                                <div class="radiocheckboxes">
                                    <label>
                                        <input type="radio" name="place_of_purchase_type" v-model="form.place_of_purchase_type" value="Retail Partner" aria-label="Retail Partner" @change="form.retailer_id = null; form.place_of_purchase = null"> In store
                                    </label>  
                                    <label>
                                        <input type="radio" name="place_of_purchase_type" v-model="form.place_of_purchase_type" value="Online" aria-label="Online" @change="form.retailer_id = null; form.place_of_purchase = null"> Online
                                    </label>    
                                </div> 
                            </div>
                        </div>                    
                        <div class="grid-x">
                            <div class="cell medium-4"><label for="place_of_purchase"  class="large">Place of purchase*</label></div>
                            <div class="cell medium-8">
                                <template v-if="form.place_of_purchase_type == 'Retail Partner'">    
                                   <p><search-autocomplete :isAsync="true" v-on:input="searchRetailers($event)" :items="retailerList" v-on:chosen="form.retailer_id = $event.id; form.place_of_purchase = $event.data" /></p>
                                </template>
                                <template v-else>
                                    <p><input type="text" id="place_of_purchase" name="place_of_purchase" v-model="form.place_of_purchase" maxlength="60"></p>
                                    <p style="margin-bottom: 2rem;"><small>Enter {{ form.place_of_purchase_type == 'Retail Partner' ? "Retail Partner's name and town" : 'full website url' }}</small></p>
                                </template>
                            </div>
                            <div class="medium-8 medium-offset-4 cell">
                                <p v-if="errors.includes('place_of_purchase')" class="error">Please tell us where you purchased the {{ form.flooring_type }}</p>    
                            </div>
                        </div>
                        <div v-if="form.place_of_purchase_type == 'Online' && form.flooring_type != 'Carpet'" class="grid-x">
                            <div class="cell medium-4"><label for="date_of_purchase" class="large">Did you use our Click 'n' Collect Service?</label></div>
                            <div class="cell medium-8 medium-4">
                                <div class="radiocheckboxes">
                                    <label>
                                        <input type="radio" name="click_n_collect" v-model="form.click_n_collect" value="Yes" aria-label="Retail Partner" @change="form.retailer_id = null; "> Yes
                                    </label>  
                                    <label>
                                        <input type="radio" name="click_n_collect" v-model="form.click_n_collect" value="No" aria-label="Online" @change="form.retailer_id = null; form.click_n_collect_retailer = null"> No
                                    </label>    
                                </div> 
                                <p v-if="errors.includes('click_n_collect')" class="error">Please choose an option</p>
                            </div>
                            <template v-if="form.click_n_collect == 'Yes'">
                            <div class="cell medium-4"><label for="date_of_purchase" class="large">Click 'n' Collect Retailer*</label></div>
                            <div class="cell medium-8 medium-4">
                                <p><search-autocomplete :isAsync="true"  v-on:input="searchRetailers($event)" :items="retailerList" v-on:chosen="form.retailer_id = $event.id; form.click_n_collect_retailer = $event.data"  /></p>  
                            </div>
                            <div class="medium-8 medium-offset-4 cell">
                                <p v-if="errors.includes('click_n_collect_retailer')" class="error">Please tell us the retailer you collected your {{ form.flooring_type }} from</p>    
                            </div>
                            </template>
                        </div>
                        <div class="grid-x">
                            <div class="cell medium-4"><label for="date_of_purchase" class="large">Date of purchase*</label></div>
                            <div class="cell medium-4">
                                <p>
                                    <VueDatePicker :enable-time-picker="false" auto-apply :format="dateFormat" id="date_of_purchase" v-model="form.date_of_purchase" v-on:setdate="form.date_of_purchase=$event" />
                                </p>
                                <p v-if="errors.includes('date_of_purchase')" class="error">Please enter valid purchase date</p>
                            </div>
                        </div>
                        <div class="grid-x">
                            <div class="cell medium-4"><label for="date_of_receipt" class="large">Collection/Fitted date*</label></div>
                            <div class="cell medium-4">
                                <p>
                                    <VueDatePicker :enableTimePicker="false" auto-apply :format="dateFormat" id="date_of_receipt" v-model="form.date_of_receipt" v-on:setdate="form.date_of_receipt=$event" />
                                </p>
                                <p v-if="errors.includes('date_of_receipt')" class="error">Please enter valid collection/fitted date</p>
                            </div>
                            <div class="medium-8 medium-offset-4 cell"><p style="margin-bottom: 2rem;"><small>Please ensure that this item was received within the last 35 days.</small></p></div>
                        </div>                        
                        <div class="grid-x">
                            <div class="cell medium-4"><label for="invoice_no"  class="large">Invoice Number</label></div>
                            <div class="cell medium-4"><p><input type="text" id="invoice_no" name="invoice_no" v-model="form.invoice_no"></p></div>                                                
                        </div> 
                    </div>
                </div>
            </div>
            <div v-if="form.place_of_purchase" class="grid-x grid-padding-x" style="padding-bottom: 2rem;">
                <div class="cell"><h2>Your Experience</h2><hr /></div>  
                <div class="large-10 large-offset-1 cell">
                    <template v-for="(item, i) in form.questions[form.place_of_purchase_type]">
                        <warranty-question :question="item.question" :answers="item.answers" :display="item.display" v-on:response="form.questions[form.place_of_purchase_type][i].selected = $event" :isError="errors.includes(item.question)" />
                            
                    </template>
                </div>
                <div class="large-10 large-offset-1 cell">
                    <div class="grid-x">    
                        <div class="cell"><hr /></div> 
                        <div class="cell">
                            <p style="margin-bottom: 1rem;">The Alternative Flooring Company Ltd respects your desire for privacy. Data collected from this form will not be given, sold or shared with any 3rd party organisations. We will only use this information to contact you about this request.</p>
                            <div class="holder">
                                <p>
                                    <span class="field checkbox">
                                        <input type="radio" id="mailing_list_no" name="mailing_list" v-model="form.mailing_list" value="no" >
                                        <label class="checkbox" for="mailing_list_no"><span class="label-text">If you <span style="font-weight:500">DO NOT</span> wish to receive details of Alternative Flooring's products or events, please tick this box</span></label>
                                    </span>
                                </p>
                                <p>
                                    <span class="field checkbox">
                                        <input type="radio" id="mailing_list_yes" name="mailing_list" v-model="form.mailing_list" value="yes">
                                        <label class="checkbox" for="mailing_list_yes"><span class="label-text">If you <span style="font-weight:500">WOULD</span> like to be kept informed of future events, products, product launches and news about Alternative Flooring, please tick this box</span></label>
                                    </span>
                                </p>                              
                            </div>
                        </div>  
                    </div>
                    <div class="grid-x">    
                        <div class="cell"><hr /></div> 
                        <div class="cell text-right">
                            <button v-if="canSubmit" name="submit" type="button" @click="submitform()" class="button form-post-button">Submit</button>
                            <p v-if="errors.length" class="error">Please check form for missing or invalid data.</p>
                        </div>   
                    </div>
                </div>           
            </div>
        </div> 


    
        <div v-show="sent" class="grid-x grid-padding-x grid-padding-y">
            <div id="submitted" ref="submitted" class="cell">
                <p class="text-center"><b>Thank you for registering your product.</b><br>You will receive a Warranty Certificate to your registered email address. Please keep this in a safe place along with your proof of purchase as both will be required in the event of a claim.</p>
                <p class="text-center"><button href="#" @click.prevent="checkloggedin()" style="text-decoration:underline; cursor:pointer;" :disabled="!canSubmit">Register another product</button></p>
            </div>
        </div>
    </form>
</template>

<script setup>

    import { onMounted, ref, inject, watch, nextTick } from 'vue'
    import RendiliCore from '@RendiliCore'
    import warrantyQuestion from './warranty-question.vue'
    import signIn from '@/components/signin.vue'
    import sampleLookup from './carpet-lookup.vue'
    import searchAutocomplete from '@/components/search-autocomplete.vue'
    import VueDatePicker from '@vuepic/vue-datepicker'
    import '@vuepic/vue-datepicker/dist/main.css'
    import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3'

    const recaptcha = useReCaptcha()
    const form = ref({})
    const sent = ref(false)
    const loggedin = ref(false)
    const errors = ref([])
    const canSubmit = ref(true)
    const retailerList = ref([])
    const email = ref(null)
    const customerName = ref(null)
    

    defineOptions({
        name: 'Warranty'
    })

    const dateFormat = (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    function checkloggedin(newform = true) {
        sent.value = false;
        RendiliCore.Json.Get('/alternative/account/isloggedin')                   
        .then(function (result) {
            loggedin.value = result;
            if(result == true && newform == true) {
                getform();
                nextTick(() =>{
                    document.getElementById('part2').style.display = "block"
                    document.getElementById('part1').style.display = "none"
                })

            } else {
                document.getElementById('part1').style.display = "block"
            }
        },function() {
            loggedin.value =  false;
            nextTick(() =>{
                document.getElementById('part1').style.display = "block"
                document.getElementById('part2').style.display = "none"
                email.value.focus()
            });
        });
    }

    function getform() {
        RendiliCore.Json.Get('/alternative/warranty/new')                   
        .then(function (result) {
            form.value = result.data;
            nextTick(() =>{
                document.getElementById('pageTop').scrollIntoView(false);
                customerName.value.focus()
            });
           
        },function() {
            errors.value.push('unknown');
        });
    }

    function searchRetailers(searchString) {
        console.log('retailr searhc', searchString)
        form.value.retailer_id = null;
        RendiliCore.Json.PostJsonData({
            url: '/alternative/retailer/search',
            data: searchString
        }).then(function(data) {
            if (data.status == 'OK') {
               retailerList.value = data.list
            } 
        });
    }

    function validate(_callback){
        var valid = true;
        errors.value = [];

        if(form.value.flooring_type == 'Carpet' || form.value.place_of_purchase_type == 'Retail Partner') {
            form.value.click_n_collect = null;
            form.value.click_n_collect_retailer = null;
        }

        if(form.value.customer_name == null) {
            errors.value.push('customer_name');
            valid = false;
        }
        if(form.value.carpet_code == null) {
            errors.value.push('carpet_code');
            valid = false;
        }
        if(form.value.flooring_type == null) {
            errors.value.push('flooring_type');
            valid = false;
        }                
        if(form.value.place_of_purchase == null) {
            errors.value.push('place_of_purchase');
            valid = false;
        }
        if(form.value.place_of_purchase_type == 'Retail Partner' && (!form.value.place_of_purchase || form.value.retailer_id == null)) {
            errors.value.push('place_of_purchase');
            valid = false;
        }
        if(form.value.place_of_purchase_type == 'Online' && form.value.flooring_type != 'Carpet'  && form.value.click_n_collect == null) {
            errors.value.push('click_n_collect');
            valid = false;
        }
        if(form.value.place_of_purchase_type == 'Online' && form.value.click_n_collect == 'Yes' && (!form.value.click_n_collect_retailer == null || form.value.retailer_id == null )) {
            errors.value.push('click_n_collect_retailer');
            valid = false;
        }
        if(form.value.date_of_purchase == null || Date.parse(form.value.date_of_purchase) > Date.parse(form.value.date_of_receipt)) {
            errors.value.push('date_of_purchase');
            valid = false;
        }                
        if(form.value.date_of_receipt == null || Date.parse(form.value.date_of_receipt) < Date.parse(new Date(form.value.cutoff_date)) || Date.parse(form.value.date_of_receipt) > new Date()) {
            errors.value.push('date_of_receipt');
            valid = false;
        }
        form.value.questions[form.value.place_of_purchase_type].forEach(f => {
            if(f.answers.length > 0 && !f.selected) {
                errors.value.push(f.question);
                valid = false;
            }
        })
        _callback(valid);
    }


    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    async function submitform(recaptchaResponse) {

        await recaptcha.recaptchaLoaded()
        const token = await recaptcha.executeRecaptcha('login')
        retailerList.value = []
        validate(function(valid) {
            //post form
            canSubmit.value = false;
            if(valid) {
                checkloggedin(false);

                var formdata = {};
                formdata['form'] = form.value;
                formdata['g-recaptcha-response'] = recaptchaResponse;
                RendiliCore.Json.PostJsonData({
                    url: '/alternative/warranty/save',
                    data: formdata
                }).then(function(data) {
                    if (data.status == 'OK') {
                        sent.value = true;
                        document.getElementById('part2').style.display = "none";
                        document.getElementById('part1').style.display = "none";
                        //window.scrollTo({ top: 50, behavior: 'smooth' });
                        nextTick(() =>{
                            document.getElementById('pageTop').scrollIntoView(false);
                        })
                        
                        canSubmit.value = true;
                    } else {
                        alert('There was a problem.');
                        recaptcha.value.reset();
                        canSubmit.value = true;
                    }
                }, function() {
                    //recaptcha.value.reset();
                    canSubmit.value = true;
                });
            } else {
                //recaptcha.value.reset();
                canSubmit.value = true;
            }
        });
    }

    onMounted(async () => {
        console.log('mounting')
        await recaptcha.recaptchaLoaded()
        recaptcha.instance.value.hideBadge()
        //document.getElementById('part2').style.display = "none"
        //document.getElementById('part1').style.display = "none"
        //document.getElementById('pageTop').scrollIntoView(false);
    // this.$refs.customerName.focus();
        if(!sent.value)
            checkloggedin();
    })


</script>